import script from "./OnboardingSlide0.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingSlide0.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingSlide0.vue?vue&type=style&index=0&id=ae820e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae820e3c"]])

export default __exports__